var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcStore = function SvgIcStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.3 5A1.7 1.7 0 0 1 5 3.3h14A1.7 1.7 0 0 1 20.7 5v14a1.7 1.7 0 0 1-1.7 1.7H5A1.7 1.7 0 0 1 3.3 19V5m1.4 14v-8c.55.394 1.223.626 1.95.626 1.086 0 2.05-.516 2.663-1.317A3.4 3.4 0 0 0 12 11.626a3.4 3.4 0 0 0 2.687-1.317 3.35 3.35 0 0 0 2.663 1.317c.727 0 1.4-.232 1.95-.626v8a.3.3 0 0 1-.3.3h-6.3v-4.4h-1.4v4.4H5a.3.3 0 0 1-.3-.3M10 5.262v2.984a2 2 0 0 0 4-.02V4.7h-4zm5.4 0V4.7H19a.3.3 0 0 1 .3.3v3.276a1.95 1.95 0 1 1-3.9 0zM8.6 8.226V4.7H5a.3.3 0 0 0-.3.3v3.276a1.95 1.95 0 1 0 3.9 0v-.05",
    clipRule: "evenodd"
  })));
};
export default SvgIcStore;